<template>
  <b-col xs="6" sm="6" md="6" lg="2" class="mt-2">
    <b-card header-class="p-0" body-class="p-0">
      <div slot="header" class="image-item"
           :style="{ backgroundImage: 'url(' + imageThumbRoute + ')' }">
      </div>
      <b-card-body class="p-1 text-container">
        <b-form-textarea  :name="'img_' + item.id" :id="'img_' + item.id" rows="2"
                         :value.sync="item.document_name" @input="changeTextField">
        </b-form-textarea>
      </b-card-body>
    </b-card>
    <b-row class="mb-2 mt-2 ml-3">
      <DownloadButton :c_permission="C_DOCUMENT_DOWNLOAD_BUTTON"
                      @click="download">Download
      </DownloadButton>
      <delete-button :c_permission="C_DOCUMENT_DELETE_BUTTON"
                     @click="showDeleteDialog=true"
                     :disabled="applicant.status && applicant.status.id === STATUS_COMPLETE"
                     class="pull-right">
      </delete-button>
    </b-row>
    <delete-dialog  :show="showDeleteDialog"
                    @confirm="removeItem"
                    @cancel="showDeleteDialog=false">
    </delete-dialog>
  </b-col>
</template>

<script>
  import SaveButton from '@/components/app/AppSubmit'
  import DownloadButton from '@/components/app/AppDownload'
  import DeleteButton from '@/components/app/AppDelete'
  import AppButton from "../../app/AppButton";
  import DeleteDialog from '@/components/app/form/AppConfirmationDialog'
  import {C_DOCUMENT_DOWNLOAD_BUTTON} from '@/shared/component_permission'
  import {C_DOCUMENT_DELETE_BUTTON} from '@/shared/component_permission'
  import {STATUS_COMPLETE} from '@/shared/constants'
    export default {
        name: "DocumentItem",
      props: {
        item: {},
        disabled: {
          type: Boolean,
          default: false
        },
        editDisabled: {
          type: Boolean,
          default: false
        },
        DocumentTypeId: {
          type: Number,
        },
        checkboxSelectedList: {
          type: Array,
          default: []
        }
      },
      components: {
        AppButton,
        DownloadButton,
        DeleteButton,
        SaveButton,
        DeleteDialog
      },
      data() {
        return {
          loadingState: false,
          showDeleteDialog:false,
          C_DOCUMENT_DOWNLOAD_BUTTON,
          C_DOCUMENT_DELETE_BUTTON,
          STATUS_COMPLETE
        }
      },
      methods: {
        saveDocumentName(){

        },
        changeTextField(val) {

          this.$emit('textfieldEdit', val)
        },
        download(){
          this.$emit('downloadDoc')
        },
        removeItem() {
          if (!this.editDisabled) {
            this.$emit('removeDocument')
          }
        },
        clickedImg() {
          this.$emit('imageClicked')
        },
        emmitChecked(event) {
          this.$emit('copyCheck', event)
        }
      },
      computed: {
        selected() {
          return this.checkboxSelectedList.includes(this.item.id)
        },
        applicant() {
          return this.$store.getters['applicant/getApplicant']
        },
        imageThumbRoute(){
          if(this.item.type === "application/pdf"){
            return 'icon/pdf.jpg'
          }
          if(this.item.type === "image/jpeg"){
            return 'icon/jpg.jpg'
          }
          if(this.item.type === "image/png"){
            return 'icon/png.jpg'
          }
          if(this.item.type === "application/msword" || this.item.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
            return 'icon/doc.jpg'
          }
        }
      },
      created(){
      }
    }
</script>

<style scoped>
  .image-item {
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    width: 100%;
    overflow: hidden;
    min-height: 10rem;
  }

  .image-zoom {
    position: absolute;
    left: 0;
    top: 0;
    color: white;
    cursor: pointer;
  }

  .image-delete {
    position: absolute;
    color: white;
    cursor: pointer;
    right: 0;
    top: 0;
  }

  .document-checkbox {
    position: absolute;
    right: 0;
    bottom: 5px;

  }

  .document-item i {
    color: black;
  }

  .document-item {
    position: relative;
    min-height: 10rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }


  .fa-shading{
    text-shadow: 0 0 8px black;
  }
</style>
